// src/campaigns/configs/index.ts

import { campaigns2026 } from "./campaigns.2026";
import { campaigns2027 } from "./campaigns.2027";
import { campaigns2028 } from "./campaigns.2028";
import { campaigns2029 } from "./campaigns.2029";
import { resolveCampaignTimeline } from "../engine/campaign-engine";

export const CAMPAIGNS = resolveCampaignTimeline([
  ...campaigns2026,
  ...campaigns2027,
  ...campaigns2028,
  ...campaigns2029,
]);
